export const heatStyle = (value, type) => {
    const pct = Math.min(Math.round((value || 0) * 100), 100);
    const color = type === 'AT' ? '#dc2626' : '#1d4ed8';
    const border = type === 'AT' ? '#991b1b' : '#1e40af';
    const emptyBorder = type === 'AT' ? 'rgba(220,38,38,0.5)' : 'rgba(29,78,216,0.5)';
    return {
        background: pct === 0 ? '#ffffff' : `linear-gradient(to top, ${color} ${pct}%, #ffffff ${pct}%)`,
        borderColor: pct > 0 ? border : emptyBorder,
    };
};
